<template>
    <filters-and-pagination
        :pagination-data="filterAndPaginationStore.referralsFiltersAndPaginationData"
        :filterable-fields="filterFields"
        :loading-data="filterAndPaginationStore.loadingFiltersAndPaginationData"
    >
        <referral-data-table :recent-activities="filterAndPaginationStore.referralsFiltersAndPaginationData.data" />
    </filters-and-pagination>
</template>

<script setup>
import FiltersAndPagination from "../filters-and-pagination/FiltersAndPagination";
import ReferralDataTable from "./components/ReferralDataTable";
import {usePortalFilterAndPaginationStore} from "../../../stores/partners/filterAndPagination";

    const props = defineProps({
        filterFields: {
            type: Object
        },
        partnerProgramActivitiesUrl: {
            type: String
        }
    })

    const filterAndPaginationStore = usePortalFilterAndPaginationStore()

</script>
